export const isScrolledIntoView = (element) => {
    const $ = jQuery;

    const docViewTop = $(window).scrollTop();
    const docViewBottom = docViewTop + $(window).height();

    const elemTop = element.offset().top;

    if (element.hasClass('animation-started')) {
        return false;
    }

    return ((elemTop <= docViewBottom) && (elemTop >= docViewTop));
}
